import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import "../CSS/Ads.css";
import bgImage from "../../Images/offer-bg.png";
import { fetchEvents } from "../../Features/Events/EventSlice";
import Image from "../../Images/event.png";
import { Grid } from "@material-ui/core";

export default function Ads() {
  const dispatch = useDispatch();

  // Fetch the events from Redux store
  const events = useSelector((state) => state.events.events);
  const loading = useSelector((state) => state.events.loading);

  useEffect(() => {
    dispatch(fetchEvents());
  }, [dispatch]);

  const latestEvent =
    events &&
    events?.find((n) => n?.event_id == sessionStorage?.getItem("event_id"));

  return (
    <Grid
      container
      className="info-card fo_css_events_ads event_ads"
      style={{
        backgroundImage: `url(${latestEvent?.event_img_path})`,
        objectFit: "strecth",
      }}
    >
      <div className="overlay"></div>
      <div className="card-content">
          <Grid item xs={2}>
            <span className="website-name">Order That</span>{" "}
            <img
              src={latestEvent?.event_logo_path || bgImage}
              alt="Website Logo"
              className="website-logo"
            />{" "} 
          </Grid>
          <Grid item xs={10} className="right-content">
              <p className="logo-line-text">
                ORDER THAT caters {latestEvent?.event_name} crowd with food and
                drinks.
              </p>{" "}
          </Grid>
      </div>
    </Grid>
  );
}